import { Component, Input } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-vitamin-d-supplement',
  templateUrl: './vitamin-d-supplement.component.html',
  imports: [UpsellCardComponent],
})
export class VitaminDSupplementComponent {
  @Input() public htmlTitle = '<strong>Boost Your Health</strong> with Vitamin D';
  @Input() public question =
    'We strongly recommend including Vitamin D your prescription. Would you like to add it to your treatment plan?';
  public readonly slug: UpsellSlugs = UpsellSlugs.VitaminDSupplement;
}
